import { Directive, ElementRef, HostListener } from '@angular/core';

/** Keep unsupported marketplace/carrier icons from rendering as broken images. */
@Directive({ selector: 'img[marketplaceIconFallback]', standalone: true })
export class MarketplaceIconFallbackDirective {
  constructor(private element: ElementRef<HTMLImageElement>) {}

  @HostListener('error') onError() {
    const image = this.element.nativeElement;
    const fallback = 'assets/media/icons/local-icon.svg';
    if (!image.src.endsWith('/' + fallback)) image.src = fallback;
  }
}
